<div class="maintenance-window-view-container" fxLayout="column" fxLayoutGap="15px">
  <div *ngIf="details" fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="10px">
      <a
        [class.disabled-link]="!(userPermissions | async)?.chronie?.admin_root"
        mat-stroked-button
        color="primary"
        (click)="modify()"
      >
        <mat-icon>create</mat-icon>
        <span> Edytuj </span>
      </a>

      <button
        (click)="toggleStatus()"
        [disabled]="processingStatus || !(userPermissions | async)?.chronie?.admin_root"
        mat-stroked-button
        [color]="details.enabled ? 'warn' : 'primary'">
        <mat-icon>{{ details.enabled ? 'pause_circle_outline' : 'play_circle_outline' }}</mat-icon>
        <span>{{ details.enabled ? 'Dezaktywuj' : 'Aktywuj' }}</span>
      </button>
    </div>
  </div>

  <mat-card *ngIf="details" fxLayout="column" fxLayoutGap="20px">
    <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column">
      <app-detail fxFlex header="Status" [value]="statusLabel"></app-detail>
      <app-detail fxFlex header="Konfiguracja" [value]="details.enabled ? 'Włączona' : 'Wyłączona'"></app-detail>
      <app-detail fxFlex header="Towarzystwo" [value]="companyName"></app-detail>
      <app-detail fxFlex header="Baner" [value]="details.noticeEnabled ? 'Włączony' : 'Wyłączony'"></app-detail>
      <app-detail fxFlex header="Blokada sprzedaży" [value]="details.blockPurchases ? 'Włączona' : 'Wyłączona'"></app-detail>
    </div>

    <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column">
      <app-detail fxFlex header="Baner od" [value]="details.displayFrom | date:'dd.MM.yyyy | HH:mm'"></app-detail>
      <app-detail fxFlex header="Baner do" [value]="details.displayTo ? (details.displayTo | date:'dd.MM.yyyy | HH:mm') : 'bez daty końcowej'"></app-detail>
      <app-detail fxFlex header="Wdrożenie od" [value]="details.startsAt | date:'dd.MM.yyyy | HH:mm'"></app-detail>
      <app-detail fxFlex header="Wdrożenie do" [value]="details.endsAt | date:'dd.MM.yyyy | HH:mm'"></app-detail>
    </div>

    <div>
      <h3>{{ details.title }}</h3>
      <p class="message">{{ details.message }}</p>
    </div>

    <div *ngIf="details.blockPurchases">
      <h3>Zakres blokady</h3>
      <p>{{ blockScope }}</p>
    </div>
  </mat-card>
</div>
